import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
// import { createCanvas } from "canvas";
import { Months } from "../../../utils/months";
import SectionTitle from "../../../common/shared/SectionTitle";
import { Button } from "@material-tailwind/react";
import ReactToPrint from "react-to-print";
import Loader from "../../../common/loader/Loader";

function PupilCert() {
    const [certificateImage, setCertificateImage] = useState(null);
    const location = useLocation();

    let componentRef = useRef();
    const canvasRef = useRef();

    const certData = location.state?.formData;

    const certYear = new Date(certData?.end_date).getFullYear();

    const formData = useMemo(
        () => ({
            year: certYear,
            cert_number: certData?.cert_number,
            name: certData?.name,
            end_date: certData?.end_date,
            senior: certData?.senior,
            chamber: certData?.chamber,
            start_date: certData?.start_date,
        }),
        [certData, certYear]
    );

    useEffect(() => {
        const generateCertificate = async () => {
            try {
                const image = new Image();
                image.src = `/cert/pupilage/pupilage${formData.year}.jpg`;

                // Wait for the image to load
                image.onload = async () => {
                    await image.decode();

                    const canvas = canvasRef.current;
                    if (!canvas) {
                        console.error("Canvas not found");
                        return;
                    }
                    const ctx = canvas.getContext("2d");
                    if (!ctx) {
                        console.error("Context not found");
                        return;
                    }

                    canvas.width = image.width;
                    canvas.height = image.height;

                    ctx.drawImage(image, 0, 0);
                    ctx.font = "bold 20px Arial";
                    ctx.fillText(formData.cert_number, 680, 137);

                    const nameText = formData.name;
                    const textWidth = ctx.measureText(nameText).width;
                    const xCoordinate = (canvas.width - textWidth) / 2;
                    ctx.fillText(nameText.toUpperCase(), xCoordinate, 635);

                    const date = new Date(formData.end_date);
                    const day = date.getDate();
                    const month = Months[date.getMonth()];
                    const yearDate = date.getFullYear();

                    ctx.fillText(dayjs(formData.start_date).format("DD/MM/YYYY"), 770, 700);
                    ctx.fillText(dayjs(formData.end_date).format("DD/MM/YYYY"), 60, 720);
                    ctx.fillText(formData.senior, 230, 720);
                    ctx.fillText(formData.chamber, 590, 720);

                    ctx.fillText(day, 250, 820);
                    ctx.fillText(month, 500, 820);
                    ctx.fillText(yearDate % 100, 740, 825);

                    const dataUrl = canvas.toDataURL("image/png");
                    setCertificateImage(dataUrl);
                };

                image.onerror = (err) => {
                    console.error("Image loading error:", err);
                };
            } catch (error) {
                console.error("Error generating certificate:", error);
            }
        };

        generateCertificate();
    }, [formData]);

    return (
        <>
            <SectionTitle title="Pupilage Certificate" description="" children={[]} />

            <div className="my-8 max-w-[1200px] m-auto px-4 flex flex-col items-center justify-center">
                <div className="flex items-center gap-3 mb-8">
                    <div>
                        <ReactToPrint
                            trigger={() => <Button>Print Cert</Button>}
                            content={() => componentRef}
                            removeAfterPrint={false}
                        />
                    </div>
                </div>

                <canvas ref={canvasRef} />

                {!certificateImage ? (
                    <Loader />
                ) : (
                    <div ref={(el) => (componentRef = el)}>
                        <img src={certificateImage} alt="Generated Certificate" />
                    </div>
                )}
            </div>
        </>
    );
}

export default PupilCert;
